<script setup lang="ts">
import { get } from '@vueuse/core'
import { defineRulesFor } from './auth/abilities'
import { useAppAbility } from './composables/AppAbility'

console.log('Retskaffen :: Loading fresh')

const { update } = useAppAbility()
const { user, loggedIn } = useUserSession()
console.log('Retskaffen :: Initial auth state', get(user))

await useUserSession().fetch()

watch(loggedIn, () => {
  console.log('Retskaffen :: Logged in changed', get(loggedIn))
  update(defineRulesFor(get(user)?.name ?? 'no-one'))
})

useHead({
  title: 'Retskaffen',
  link: [
    { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
    { rel: 'icon', type: 'image/png', href: '/favicon-96x96.png', sizes: '96x96' },
    { rel: 'shortcut icon', href: '/favicon.ico' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
    { rel: 'manifest', href: '/site.webmanifest' },
    { rel: 'stylesheet', href: 'https://db.onlinewebfonts.com/a/Aw0g00aal1FO50ry', type: 'text/css' },
  ],
  meta: [{ name: 'apple-mobile-web-app-title', content: 'Retskaffen' }],
  htmlAttrs: {
    class: 'dark',
  },
})
</script>

<template>
  <Head>
    <Meta
      name="color-scheme"
      content="dark"
    />
  </Head>

  <div>
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <LogoutButton />
      <NuxtPage />
    </NuxtLayout>
    <UNotifications />
  </div>
</template>

<style lang="css">
body {
  background: #18181b;
}
</style>
